import React from 'react';
import pulseImage from 'images/pulseCta.jpg';
import { TRACKING } from 'common/constants/constants';
import CtaPage from 'components/CtaPage';
import { Flex } from 'components/base/layout-components';
import { TEXT_POSITION } from 'components/CtaPage/constants';

const SECTION_TYPES = {
  PEOPLE: 'PEOPLE',
  ISSUES: 'ISSUES',
  ACTIVITY: 'ACTIVITY'
};

const TEXTS = {
  [SECTION_TYPES.PEOPLE]:
    "Using the Pulse Dashboard to visualize your team's" +
    ' sprint progress and potential risks. Toggle between' +
    ' ticket status, ticket type or by team member to see' +
    ' where your team is making progress, what people are' +
    " working prioritizing and the unlinked work that isn't" +
    ' being documented.',
  [SECTION_TYPES.ISSUES]:
    'Understanding how each issue is progressing is easy' +
    ' with the Pulse Dashboard. In this section of the' +
    ' dashboard you will see each issue associated with' +
    " the sprint and it's status in terms of git progress," +
    ' owners, story points and board status.',
  [SECTION_TYPES.ACTIVITY]:
    'Pulse correlates data between your Project Management' +
    ' tool and git provider. In this view you will see the ' +
    'git activity by volume, type and date. You will also ' +
    'be alerted to sprint delivery risks like long PR review times.'
};
const PulseCTA = () => (
  <Flex grow='1' padding='small'>
    <CtaPage
      textsMap={TEXTS}
      page={TRACKING.PAGES.PULSE}
      pageTab={TRACKING.PAGE_TABS.PULSE_CTA}
      buttonLineProps={{
        leftText: 'DE-RISK YOUR SPRINTS!',
        buttonText: 'SCHEDULE A WALKTHROUGH'
      }}
      backgroundImage={pulseImage}
      sections={[
        {
          sectionType: SECTION_TYPES.PEOPLE,
          buttonPosition: {
            left: '45%',
            top: '7.5rem'
          },
          coverProps: {
            height: '11.45rem',
            width: '100%',
            position: { top: 0 }
          },
          textPosition: { right: TEXT_POSITION, top: '5rem' }
        },
        {
          sectionType: SECTION_TYPES.ISSUES,
          buttonPosition: {
            bottom: '19rem',
            left: '22rem'
          },
          coverProps: {
            height: '38rem',
            width: '44rem',
            position: { bottom: 0 }
          },
          textPosition: { left: TEXT_POSITION, top: '16.2rem' },
          isTextLeft: true
        },
        {
          sectionType: SECTION_TYPES.ACTIVITY,
          buttonPosition: {
            bottom: '19rem',
            right: '20rem'
          },
          coverProps: {
            height: '38rem',
            width: '39.75rem',
            position: {
              bottom: 0,
              right: 0
            }
          },
          textPosition: { right: TEXT_POSITION, top: '16rem' }
        }
      ]}
    />
  </Flex>
);

export default PulseCTA;
